import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import * as S from './MarkedValue.styles';

const MarkedValue = ({
  formattedFieldId,
  getActiveResultId,
  handleSearchResults,
  value,
  vehicleDetailsSearchString,
}) => {
  if (isEmpty(vehicleDetailsSearchString)) {
    return value;
  }

  const stringValue = typeof value === 'number' ? value.toString() : value;

  if (!stringValue) {
    return null;
  }

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };

  const safeSearch = escapeRegExp(vehicleDetailsSearchString);
  const splitStringArray = stringValue.split(new RegExp(`(${safeSearch})`, 'gi'));

  return (
    <>
      {splitStringArray.map((val, index) => {
        if (!val || val === '') {
          return null;
        } else if (
          vehicleDetailsSearchString &&
          val.toLowerCase() === vehicleDetailsSearchString.toLowerCase()
        ) {
          const fieldIdWithIndex = `${formattedFieldId}-${index}`;
          const activeResultId = getActiveResultId();
          handleSearchResults(fieldIdWithIndex);
          const isActive = fieldIdWithIndex === activeResultId;
          return (
            <S.Mark key={`${val}-${index}`} isActive={isActive} data-testid="highlighted">
              {val}
            </S.Mark>
          );
        } else {
          return val;
        }
      })}
    </>
  );
};

MarkedValue.propTypes = {
  formattedFieldId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  getActiveResultId: PropTypes.func,
  handleSearchResults: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  vehicleDetailsSearchString: PropTypes.string,
};

export default MarkedValue;
